<template>
    <div class="register" :style="{'backgroundImage':'url('+loginBgImageUrl+')'}">
        <div class="cont">
        <div class="register-main">
            <!-- ============= 左侧图片 ============= -->
            <div class="left">
                <img src="../../assets/images/login/sign-in.png">
            </div>

            <!-- ============= 用户注册信息 ============= -->
            <div class="register-box">
                <el-form class="register-form" :model="account">
                    <span style="margin-left: 18px;">用户名:</span>
                    <el-input class="user-info-input" v-model="account.userName">
                    </el-input><br>

                    <span style="margin-left: 28px;">密 码:</span>
                    <el-input class="user-info-input" v-model="account.passWord">
                    </el-input><br>

                    <span>确认密码:</span>
                    <el-input class="user-info-input" v-model="account.confirmPassWord">
                    </el-input><br>

                    <span>邮箱地址:</span>
                    <el-input class="user-info-input" v-model="account.email">
                    </el-input><br>

                    <span class="user-info-span">联系电话:</span>
                    <el-input class="user-info-input" v-model="account.phoneNumber">
                    </el-input><br>

                    <span>联系地址:</span>
                    <el-input class="user-info-input" v-model="account.address">
                    </el-input><br>
                </el-form>

                 <!-- 用户兴趣栏 -->
                <div class="interest" style="margin-top: 20px;color: #666666">
                    <span class="interest-span" style="margin-left: 36px;">挑选你感兴趣的资料(当有资料更新时将发送至您注册的邮箱)</span><br>
                    <el-checkbox class="interest-checkbox" v-model="newActivity" id="newActivity"  label="1" style="margin-left: 36px;margin-top: 10px;">最新活动</el-checkbox>
                    <el-checkbox class="interest-checkbox" v-model="news" id="news"  label="1" >最新新闻</el-checkbox>
                    <el-checkbox class="interest-checkbox" v-model="skillData" id="skillData"  label="1" >技术资料</el-checkbox>
                    <el-checkbox class="interest-checkbox" v-model="others" id="others"  label="1" >其他</el-checkbox>
                </div>

                <!-- 用户留言 -->
                <div class="leave-message">
                    <span class="leave-message-span">用户留言</span>
                    <el-input
                      v-model = "leaveMessage"
                      :rows = "3"
                      type = "textarea"
                      style = "width: 435px;margin-left: 36px;margin-top: 15px"></el-input>
                </div>

                 <!-- 重置与提交按钮 -->
                <div class="reset-submit">
                    <el-button class="reset-button" type="primary" @click="userReset" :loading="isLoad">重置</el-button>
                    <el-button class="submit-button" type="primary" @click="userSubmit" :loading="isLoad">提交</el-button>
                </div>
            </div>
      </div>
    </div>
  </div>

</template>


<script>
    export default {
        created() {

        },
        data() {
            return {
                isLoad:false,
                loginBgImageUrl : require("../../assets/images/login/login-background.png"),
                nextLogin:true, // 下次自动登录
                news: false,
                newActivity: false,
                skillData: false,
                others: false,
                account: {
                    userName: '',
                    passWord: '',
                    confirmPassWord: '',
                    email:'',
                    phoneNumber:'',
                    address:'',
                },
                leaveMessage:'',
            }
        },
        mounted() {

        },
        watch:{


        },
        methods: {
            // 用户重置
            userReset() {

            },

            // 用户提交
            userSubmit() {

            },

            // 回车自动登录
            enterSearch:function(e){
              e.target.blur();
              this.sendLogin();
            },
        }
    }
</script>

<style>
  .register { display: table; width: 100%;height: 840px; min-height: 100%; background-size: cover; }
  .register > .cont { display: table-cell; text-align: center; vertical-align: middle; }
  .register > .cont .register-main { display: inline-block; margin: 0 auto;  text-align: left; }
  .register > .cont .register-main > .register-box { width: 560px;height: 668px; background-color: #fff; margin-left: 457px; }
  .register > .cont .register-main > .left { margin-left: 30px;width: 440px; float: left; position: relative; }
  .register > .cont .register-main > .left img { width: 427px; height: 667px;  }

  .register .user-info-input { width: 360px;margin-top: 15px }
  .register .interest .interest-checkbox { margin-left: 5px;color: #333333 }
  .register .register-form { margin-left: 50px;padding-top: 20px;color: #666666 }
  .register .leave-message { margin-top: 20px }
  .register .leave-message-span { font-size: 16px;margin-left: 36px;color: #666666 }
  .register .reset-submit { margin-left: 50px  }
  .register .reset-button { width: 100px;margin-top: 30px }
  .register .submit-button { width: 320px;margin-top: 30px }
</style>



// WEBPACK FOOTER //
// src/pages/login/register.vue